import * as GlobalStylesVariables from "globalStylesVariables";
import { createUseStyles } from "react-jss";

export const useGlobalStyles = createUseStyles({
  "@global": {
    "body": {
      "--direction": "ltr",
      "--rtl-inverted": 1,
      "direction": "var(--direction)",
      "fontFamily": "Poppins, sans-serif",
      "fontSize": "1rem",
      "height": "100%",
      "margin": 0,
      "textRendering": "auto",
      "width": "100%",
    },

    "body.rtl": {
      "--direction": "rtl",
      "--rtl-inverted": -1,
    },

    "*": {
      boxSizing: "border-box",
    },

    "html": {
      "fontSize": "14px",
      "height": "100%",
      "margin": 0,
      "overflowX": "hidden",
      "touchAction": "manipulation",
      "width": "100%",

      /* New (UX Refresh) Design System */

      /* Spacing */
      "--spacing-x0": "0px",
      "--spacing-x05": `${GlobalStylesVariables.SPACING_X1 * 0.5}px`,
      "--spacing-x1": `${GlobalStylesVariables.SPACING_X1}px`,
      "--spacing-x2": `${GlobalStylesVariables.SPACING_X1 * 2}px`,
      "--spacing-x3": `${GlobalStylesVariables.SPACING_X1 * 3}px`,
      "--spacing-x4": `${GlobalStylesVariables.SPACING_X1 * 4}px`,
      "--spacing-x5": `${GlobalStylesVariables.SPACING_X1 * 5}px`,
      "--spacing-x6": `${GlobalStylesVariables.SPACING_X1 * 6}px`,
      "--spacing-x7": `${GlobalStylesVariables.SPACING_X1 * 7}px`,
      "--spacing-x8": `${GlobalStylesVariables.SPACING_X1 * 8}px`,
      "--spacing-x9": `${GlobalStylesVariables.SPACING_X1 * 9}px`,
      "--spacing-x10": `${GlobalStylesVariables.SPACING_X1 * 10}px`,
      "--spacing-x11": `${GlobalStylesVariables.SPACING_X1 * 11}px`,
      "--spacing-x12": `${GlobalStylesVariables.SPACING_X1 * 12}px`,
      "--spacing-x13": `${GlobalStylesVariables.SPACING_X1 * 13}px`,
      "--spacing-x14": `${GlobalStylesVariables.SPACING_X1 * 14}px`,

      /* Typography */
      "--typography-font-weight-light": "300",
      "--typography-font-weight-regular": "400",
      "--typography-font-weight-medium": "500",
      "--typography-font-weight-semibold": "600",
      "--typography-font-weight-bold": "700",

      /* with assuming REM is 16px */
      "--typography-font-size-tiny": "0.625rem",
      "--typography-font-size-small": "0.75rem",
      "--typography-font-size-text": "0.875rem",
      "--typography-font-size-body": "1rem",
      "--typography-font-size-title": "1.25rem",
      "--typography-font-size-h2": "1.5rem",
      "--typography-font-size-h1": "1.875rem",
      "--typography-font-size-header": "2rem",
      "--typography-font-size-lg-header": "3rem",
      /* with relative units */
      "--typography-font-size-relative-tiny": "0.625em",
      "--typography-font-size-relative-small": "0.75em",
      "--typography-font-size-relative-text": "0.875em",
      "--typography-font-size-relative-body": "1em",
      "--typography-font-size-relative-title": "1.25em",
      "--typography-font-size-relative-h2": "1.5em",
      "--typography-font-size-relative-h1": "1.875em",
      "--typography-font-size-relative-header": "2em",
      "--typography-font-size-relative-lg-header": "3em",

      /* Shadows */
      "--shadow-bottom": "0px 8px 7px 7px rgba(0, 0, 0, 0.20)",
      /* ------------------------------------------ /*

      /* Old (Dana) Design System  */
      "--transition-easing": "cubic-bezier(0.4, 0, 0.2, 1)",
      "--transition-easing-reversed": "cubic-bezier(0.8, 0, 0.6, 1)",

      /* -> General */
      "--border-radius-round": "50%",
      "--border-radius-semi-rounded": "8px",
      "--border-radius-sharp": "4px",
      "--border-radius-rounded": "12px",
      "--border-radius-rounder": "24px",
      "--border-color": "rgb(218, 229, 246)",
      /* -> Typography */
      /* ---> Sizes */
      "--typography-standard-font-size": "1rem",
      "--typography-small-font-size": "0.857rem",
      "--typography-tiny-font-size": "0.71rem",
      "--typography-h1-font-size": "2.14rem",
      "--typography-h2-font-size": "1.715rem",
      "--typography-h3-font-size": "1.14rem",
      "--typography-section-title-font-size": "1.14rem",

      "--typography-relative-standard-font-size": "1em",
      "--typography-relative-small-font-size": "0.857em",
      "--typography-relative-tiny-font-size": "0.71em",
      "--typography-relative-h1-font-size": "2.14em",
      "--typography-relative-h2-font-size": "1.715em",
      "--typography-relative-h3-font-size": "1.14em",
      "--typography-relative-section-title-font-size": "1.14em",

      /* -> Icons */
      /* ---> Sizes */
      "--icon-small-size": "0.857em",
      "--icon-medium-size": "1.14em",
      "--icon-large-size": "1.25em",
      "--icon-xl-size": "1.5em",
    },

    "@media (prefers-color-scheme: dark)": {},

    "#app": {
      height: "100%",
      width: "100%",
    },

    /* These webkit selectors work in most browsers, but not in Firefox */

    "::-webkit-scrollbar": {
      width: `${GlobalStylesVariables.SCROLLBAR_SIZE_PX}px`,
      height: `${GlobalStylesVariables.SCROLLBAR_SIZE_PX}px`,
    },

    "::-webkit-scrollbar-thumb": {
      background: "transparent",
      borderRadius: "30px",
    },

    "::-webkit-scrollbar-thumb:hover": {
      background: "var(--muted-foreground)",
    },

    "::-webkit-scrollbar-track": {
      background: "transparent",
      borderRadius: "30px",
    },

    "div:hover": {
      "&::-webkit-scrollbar-thumb": {
        background: "var(--border)",
      },
    },
  },
});
